// api/user-settings.api.ts
import axiosInstance from './axios-instance';

export interface UserSettingsDto {
  showSensitiveContent?: boolean;
}

export interface UpdateUserSettingsRequest {
  showSensitiveContent?: boolean;
  articleId?: string;
  commentId?: string;
}

export interface UserSettings {
  id: string;
  userId: string;
  showSensitiveContent: boolean;
}

export interface UserSettingsResponse {
  success: boolean;
  message: string;
  data?: UserSettings;
}

export const userSettingsApi = {
  // Update user settings
  updateUserSettings: async (
    settings: UpdateUserSettingsRequest
  ): Promise<UserSettingsResponse> => {
    const { data } = await axiosInstance.post('/api/v1/publisher/user/update-settings', settings);
    return data;
  }
};
